module.exports = "<div class=\"user-details-component user-invoices\">\r\n  <div class=\"title\">\r\n    <h4>\r\n      <span class=\"fa fa-dollar\"></span>\r\n      INVOICES\r\n    </h4>\r\n  </div>\r\n  <div class=\"details\">\r\n    <div class=\"invoices-grid\">\r\n      <div id=\"invoices-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n    </div>\r\n  </div>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/common/Components/user-invoices/user-invoices.html
 ** module id = 702
 ** module chunks = 0
 **/